import {
  Contracts_RegisterConsentRequestModel,
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type RegisterConsent = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  requestBody?: Contracts_RegisterConsentRequestModel;
};
/**
 * Register consent to customer's contract
 *
 * @returns any Success
 */
export function registerConsent(
  { businessUnit, label, customerId, requestBody }: RegisterConsent,
  requestConfig: ApiRequestConfig = {},
): Promise<any> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/contracts/meterregime`,
      body: requestBody,
    },
    requestConfig,
  );
}
